import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useApi } from '../../hooks/useApi';
import LoadingSpinner from '../../components/Common/LoadingSpinner';
import { ArrowLeftIcon, PencilIcon } from '@heroicons/react/24/outline';

const EventTypeDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { get, loading } = useApi();
  const [eventType, setEventType] = useState(null);

  useEffect(() => {
    fetchEventType();
  }, [id]);

  const fetchEventType = async () => {
    const { data } = await get(`/api/event-types/${id}`);
    if (data) setEventType(data);
  };

  if (loading) return <LoadingSpinner />;
  if (!eventType) return <div className="p-6">Event Type not found</div>;

  return (
    <div className="p-6 max-w-2xl mx-auto">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center">
          <button
            onClick={() => navigate('/event-types')}
            className="mr-4 text-gray-600 hover:text-gray-900"
          >
            <ArrowLeftIcon className="h-6 w-6" />
          </button>
          <h1 className="text-2xl font-bold text-gray-800">Event Type Details</h1>
        </div>
        <button
          onClick={() => navigate(`/event-types/edit/${id}`)}
          className="bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 flex items-center space-x-2"
        >
          <PencilIcon className="h-5 w-5" />
          <span>Edit</span>
        </button>
      </div>

      <div className="bg-white rounded-xl shadow-lg p-6">
        <div className="space-y-6">
          <div>
            <label className="text-sm text-gray-500">ID</label>
            <p className="text-lg font-medium">{eventType.id}</p>
          </div>
          <div>
            <label className="text-sm text-gray-500">Description</label>
            <p className="text-lg font-medium">{eventType.description}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventTypeDetails;